import { createSlice } from '@reduxjs/toolkit';

interface ThemeState {
  theme: 'light' | 'dark';
}

const initialState: ThemeState = {
  theme: 'light',
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
      
      // Update localStorage
      localStorage.setItem('darkMode', (state.theme === 'dark').toString());
      
      // Update document classes for Tailwind
      const html = document.documentElement;
      const body = document.body;
      
      if (state.theme === 'dark') {
        html.classList.add('dark');
        body.classList.add('dark');
        html.style.colorScheme = 'dark';
      } else {
        html.classList.remove('dark');
        body.classList.remove('dark');
        html.style.colorScheme = 'light';
      }
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
      
      // Update localStorage
      localStorage.setItem('darkMode', (state.theme === 'dark').toString());
      
      // Update document classes for Tailwind
      const html = document.documentElement;
      const body = document.body;
      
      if (state.theme === 'dark') {
        html.classList.add('dark');
        body.classList.add('dark');
        html.style.colorScheme = 'dark';
      } else {
        html.classList.remove('dark');
        body.classList.remove('dark');
        html.style.colorScheme = 'light';
      }
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer; 